var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"grecaptcha",attrs:{"data-theme":_vm.dark || _vm.ie === 'ebr' ? 'dark' : 'light'}})
}
var staticRenderFns = []

export { render, staticRenderFns }